import { compose, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist-indexeddb-storage';
import { extractStateFromAddress } from '../helpers/address';
import axios from 'axios';

import rootReducer from "./reducers";


const persistConfig = {
	key: 'root',
	storage: storage('sports and style')
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default (initialState) => {
	const middleware = [thunk];
	
	// Ensure languages are properly initialized as arrays
	const safeInitialState = {
		...initialState,
		languages: {
			languages: Array.isArray(initialState && initialState.languages && initialState.languages.languages) ? initialState.languages.languages : [],
			language: Array.isArray(initialState && initialState.languages && initialState.languages.language) ? initialState.languages.language : []
		}
	};
	
	const store = createStore(
		persistedReducer,
		safeInitialState,
		compose(
			applyMiddleware(...middleware)
			//window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
		)
	);

	store.subscribe(() => {
		const state = store.getState();
		//save the config to localstorage
		for (const setting in state.settings.settings) {
			if (state.settings.settings.hasOwnProperty(setting)) {
				const element = state.settings.settings[setting];
				localStorage.setItem(element.key, element.value);
			}
		}

		for (const translation in state.languages.language) {
			if (state.languages.language.hasOwnProperty(translation)) {
				const trans = state.languages.language[translation];
				localStorage.setItem(translation, trans);
			}
		}

		// const persist = {
		// 	cart: state.cart,
		// 	total: state.total,
		// 	items: state.items,
		// 	pages: state.pages,
		// 	user: state.user,
		// 	addresses: state.addresses,
		// 	delivery_user: state.delivery_user,
		// 	languages: state.languages.languages,
		// 	settings: state.settings,
		// };
		// localForage.setItem("state", JSON.stringify(persist));
	});
	const persistor = persistStore(store);
	return { store, persistor };
};

export async function fetchEcommerceStores() {
	// Try to get the address from geoLocation or userSetAddress
	let address = '';
	const geoLocation = localStorage.getItem('geoLocation');
	if (geoLocation) {
		const geoObj = JSON.parse(geoLocation);
		address = geoObj.formatted_address || '';
	} else if (localStorage.getItem('userSetAddress')) {
		const userSetAddress = JSON.parse(localStorage.getItem('userSetAddress'));
		address = userSetAddress.address || '';
	}
	const state = extractStateFromAddress(address);
	// Optionally, send lat/lng as well
	let lat = '', lng = '';
	if (geoLocation) {
		const geoObj = JSON.parse(geoLocation);
		lat = geoObj.geometry && geoObj.geometry.location && geoObj.geometry.location.lat ? geoObj.geometry.location.lat : '';
		lng = geoObj.geometry && geoObj.geometry.location && geoObj.geometry.location.lng ? geoObj.geometry.location.lng : '';
	}
	// Call the backend API
	const response = await axios.post('/api/v2/ecommerce-stores', { state, lat, lng });
	return response.data;
}